import { render, staticRenderFns } from "./AddDish.vue?vue&type=template&id=29e2214d&scoped=true"
import script from "./AddDish.vue?vue&type=script&lang=ts"
export * from "./AddDish.vue?vue&type=script&lang=ts"
import style0 from "./AddDish.vue?vue&type=style&index=0&id=29e2214d&prod&lang=scss"
import style1 from "./AddDish.vue?vue&type=style&index=1&id=29e2214d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_fdc8552a8ede636d403bf9928f1c7af2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e2214d",
  null
  
)

export default component.exports